import {
    filterUserList,
    filterUserListComplete,
    load,
    loadAllComplete,
    loadComplete,
} from "./PresentersActions";
import { put, takeEvery } from "redux-saga/effects";
import PresentersEvents from "./PresentersEvents";
import PresentersApi from "./PresentersApi";
import { FilterResult } from "./models/UserFilter";
import { UserData } from "../user/User";

function* loadAllWorker() {
    const users: UserData[] = yield PresentersApi.getAllUserInfo();

    yield put(loadAllComplete(users));
}

function* loadWorker(action: ReturnType<typeof load>) {
    const userInfo: UserData = yield PresentersApi.getUserInfo(action.id);

    yield put(loadComplete(userInfo));
}

function* loadfilteredUserList({ filters }: ReturnType<typeof filterUserList>) {
    const filterResult: FilterResult = yield PresentersApi.getUserByFilter(filters);
    yield put(filterUserListComplete(filterResult));
}

export default function* PresentersSaga() {
    yield takeEvery(PresentersEvents.LoadAll, loadAllWorker);
    yield takeEvery(PresentersEvents.Load, loadWorker);
    yield takeEvery(PresentersEvents.filterUserListStarted, loadfilteredUserList);
}
